<template>
  <div class="welcome-banner">
    <img src="@/assets/L2welcome.jpg" alt="Welcome banner" />
  </div>
  <h2>{{ $t('dialogs.welcomeTitle') }}</h2>
  <p>
    {{ $t('dialogs.welcomeDescription') }}
  </p>
  <div class="button-group">
    <p-button class="btn p-button-secondary" label="Close" @click="close" />
    <p-button
      class="btn p-button-primary"
      label="Learn More"
      @click="learnMoreRedirect"
    />
  </div>
</template>

<script setup lang="ts">
import { inject } from 'vue';
const dialogRef = inject('dialogRef');

function close() {
  dialogRef.value.close();
}

function learnMoreRedirect() {
  const href = 'https://lumio.io/';
  window.open(href, '_blank', 'noreferrer noopenner');
  close();
}
</script>

<style scoped lang="scss">
.btn {
  width: 100%;
  margin-top: 10px;
}

.step {
  ::v-deep(.p-blockui) {
    opacity: 0;
  }
}
.p-dialog-content {
  p {
    margin-top: 0;
    line-height: 1.4;
  }
}

h2 {
  font-size: 20px;
  font-weight: 500;
  line-height: 28px;
  letter-spacing: 0.15000000596046448px;
  text-align: center;
}

p {
  font-size: 15px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.4399999976158142px;
  text-align: center;
  color: #d4c4ed;
}

.button-group {
  display: flex;
  justify-content: space-between;
  column-gap: 1.5rem;
}

.welcome-banner {
  margin-left: -1.5rem;
  img {
    max-width: 483px;
    width: 120%;
  }
}

::v-global(.p-dialog:has(.welcome-banner) .p-dialog-header) {
  margin-bottom: -80px;
}

::v-global(.p-dialog:has(.welcome-banner) .p-dialog-content) {
  border-radius: 24px;
}
</style>
